import { createAction, handleActions } from 'redux-actions';

const isUnderAddUsersToUserGroupRoute = new RegExp('/user-groups/(.*)/o/add-users');

export const userGroupNonMembersFetchInitialized = createAction(
  '@platform/query/userGroupExcludedMembers/list/init',
);
export const userGroupNonMembersFetchSucceeded = createAction(
  '@platform/query/userGroupExcludedMembers/list/success',
  payload => payload,
);
export const userGroupNonMembersFetchFailed = createAction(
  '@platform/query/userGroupExcludedMembers/list/failed',
);
export const userGroupAddMemberInitialized = createAction(
  '@platform/command/userGroupExcludedMembers/create/init',
);
export const userGroupAddMemberSucceeded = createAction(
  '@platform/command/userGroupExcludedMembers/create/success',
);
export const userGroupAddMemberFailed = createAction(
  '@platform/command/userGroupExcludedMembers/create/failed',
);
export const configureNonMembersList = createAction(
  '@platform/event/userGroupExcludedMembers/configureFetch',
  payload => payload,
);

export interface IFilters {
  search: string
  offset?: number
  limit?: number
  sort?: '-email' | 'email'
}

interface IUser {
  id: string
  type: 'ppms/user'
  attributes: {
    email: string
  }
}
export interface IChangeUserGroupMappingPayload {
  data: {
    id: string
    type: string
  }[]
}

export interface IRouterPayload {
  location: {
    pathname: string
  }
}

export interface INonMembersPayload {
  data: IUser[]
  meta: {
    total: number
  }
}

export interface INonMembersState {
  isLoading: boolean
  list: IUser[]
  total: number
  failed: boolean
}

export const initialState: INonMembersState = {
  isLoading: false,
  list: [],
  total: 0,
  failed: false,
};

const reducer = handleActions<INonMembersState, INonMembersPayload & IRouterPayload>({
  [userGroupNonMembersFetchInitialized.toString()]: state => ({
    ...state,
    list: [],
    failed: false,
    isLoading: true,
  }),
  [userGroupNonMembersFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    list: payload.data,
    total: payload.meta.total,
  }),
  [userGroupNonMembersFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!isUnderAddUsersToUserGroupRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
